import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripePaymentForm from '../StripePaymentForm/StripePaymentForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const StripeCheckout = ({
  price,
  description,
  basePrice,
  tax,
  autoCheckTerms,
  currency,
  metadata,
  prefillEmail,
  prefillName,
  hideTaxBreakdown,
  onSuccess,
  successCtaUrl,
  successCtaLabel,
  subscriptionMode,
  intervalMonths,
}) => {
  return (
    <Elements stripe={stripePromise}>
      <StripePaymentForm
        price={price}
        description={description}
        basePrice={basePrice}
        tax={tax}
        autoCheckTerms={autoCheckTerms}
        currency={currency}
        metadata={metadata}
        prefillEmail={prefillEmail}
        prefillName={prefillName}
        hideTaxBreakdown={hideTaxBreakdown}
        onSuccess={onSuccess}
        successCtaUrl={successCtaUrl}
        successCtaLabel={successCtaLabel}
        subscriptionMode={subscriptionMode}
        intervalMonths={intervalMonths}
      />
    </Elements>
  );
};

export default StripeCheckout;
